/* 🤖 this file was generated by svg-to-ts */
export const matIconExposureNeg1: {
  name: 'exposure-neg-1';
  data: string;
} = {
  name: 'exposure-neg-1',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"/></svg>`
};
